/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { sizes } from '@smartsheet/lodestar-core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  getRunStateString,
  selectedRunSelector,
} from '../../../../../../services/ducks/workflowRunDuck/workflowRunDuck';
import { convertWorkflowRunStateToUI } from '../../../../../../utils/filePathVisitorUtils';
import { timeDifference } from '../../../../../../utils/time';
import { Column } from '../../../../../common/Column';
import { CompletedIcon } from '../../../../../icons/CompletedIcon';
import { InProgressIcon } from '../../../../../icons/InProgressIcon';
import { StopIcon } from '../../../../../icons/StopIcon';

const statusTextStyle = css`
  font-size: 18px;
  margin: 0 0 0 0;
`;

const statusIcons = {
  0: <InProgressIcon />,
  100: <InProgressIcon />,
  110: <InProgressIcon />,
  200: <StopIcon />,
  210: <StopIcon />,
  300: <CompletedIcon />,
};

export const containerStyle = css`
  padding: ${sizes.medium}px 0;
  border-bottom: 2px solid #e0e0e0;
  column-gap: 10px;
  height: 82px;

  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
`;
export const statusContainerStyle = css`
  align-items: center;
  column-gap: ${sizes.xSmall}px;
  margin-bottom: ${sizes.xSmall}px;
`;
const runDurationStyle = css`
  margin-top: 12px;
  margin-left: 30px;
  font-weight: 500;
`;

export const RunState = () => {
  const { t: translate } = useTranslation();
  const selectedRun = useSelector(selectedRunSelector);
  if (!selectedRun) return null;
  const runState = convertWorkflowRunStateToUI(selectedRun.state);
  return (
    <div css={containerStyle}>
      <Column css={statusContainerStyle}>
        {statusIcons[runState]}
        <h4 css={statusTextStyle}>{getRunStateString(runState)}</h4>
      </Column>
      <span css={runDurationStyle}>
        {`${translate('designer:runLog.runDuration')}: ${timeDifference(
          selectedRun.createTime,
          selectedRun.lastUpdateTime
        )}`}
      </span>
    </div>
  );
};
